import RouteComponent from './Route/routes';

function App() {
  return (
    <div className="App">
        <RouteComponent />
    </div>
  );
}

export default App;